class StoreLocator {
	constructor() {
		this.popup = document.querySelector(".store-locator");
		if (!this.popup) {
			return;
		}
		this.resellersContainer = this.popup.querySelector(".results");
		this.resellers = [];
		this.selectedReseller = document.querySelector(".selected-reseller");
		this.selectedResellerEmail = document.querySelector("#resellerEmail");
		this.openStoreLocatorButtons = document.querySelectorAll(".open-store-locator");
		this.openStoreLocatorButtons.forEach(button => {
			button.addEventListener("click", () => {
				this.popup.classList.add("active");
				this.popup.classList.remove("no-choose");
				this.openStoreLocator();
			});
		});
		this.openStoreLocatorWithoutChoose = document.querySelectorAll(`a[href="#find-a-reseller"]`);
		this.openStoreLocatorWithoutChoose.forEach(button => {
			button.addEventListener("click", e => {
				e.preventDefault();
				this.popup.classList.add("active");
				this.popup.classList.add("no-choose");
				this.openStoreLocator();
			});
		});

		if (window.location.hash && window.location.hash === "#find-a-reseller") {
			this.popup.classList.add("active");
			this.popup.classList.remove("no-choose");
			this.openStoreLocator();
		}

		this.popup.querySelector(".close").addEventListener("click", () => {
			this.popup.classList.remove("active");
		});
		this.popup.querySelector(".overlay").addEventListener("click", () => {
			this.popup.classList.remove("active");
		});
	}

	openStoreLocator() {

		if (!this.loaded) {
			this.loaded = true;
			LoadScript.load("https://maps.googleapis.com/maps/api/js?key=AIzaSyCMYbZ_4IJhFhBeekOAL1d08rDddCu8idA&libraries=places", () => {
				LoadScript.load(`${mcubeArgs.themeLink}/lib/markerclustererplus.min.js`, () => {
					this.buildMap();
					this.buildClusterer();
					this.getResellers();
				});
			});
		}
	}

	buildClusterer() {
		const styles = [
			[
				{
					width: 30,
					height: 30,
					className: 'custom-clustericon-1'
				},
				{
					width: 30,
					height: 30,
					className: 'custom-clustericon-2'
				},
				{
					width: 40,
					height: 40,
					className: 'custom-clustericon-3'
				}
			]
		];

		this.clusterer = new MarkerClusterer(this.map, [], {
			gridSize: 40,
			maxZoom: 12,
			clusterClass: 'custom-clustericon',
			styles: styles[0],
			ignoreHidden: true
		});
	}

	getResellers() {
		fetch("/jlfpro-resellers/").then(r => {
			return r.json();
		})
			.then(response => {
				for (let i = 0; i < response.length; i++) {
					this.addReseller(response[i]);
				}
				this.popup.classList.remove("loading");
				this.buildMarkers(response);
				this.clusterer.repaint();
				this.buildFilters();
			});
	}

	addReseller(reseller) {
		this.resellersContainer.insertAdjacentHTML("beforeend", `
			<div class="reseller ${reseller.email ? "has-email" : "no-email"}"
			     data-id="${reseller.id}"
			     data-search="${reseller.title}">
				<div class="meta">
					<div class="name">${reseller.title}</div>
					<div class="address">
						${reseller.address_1} ${reseller.address_2} ${reseller.address_3}
						<br>
						${reseller.zipcode} ${reseller.city} ${reseller.country}
					</div>
					<a href="mailto:${reseller.email}" class="email" target="_blank">${reseller.email}</a>
					<a href="${reseller.website}" class="website" target="_blank" rel="noreferrer noopener nofollow">${reseller.website}</a>
					<div class="choose-reseller text-underline-arrow ${reseller.email ? "" : "d-none"}" data-email="${reseller.email}">${mcubeArgs.chooseThisDealer}</div>
					<div class="zoom-on-map">${mcubeArgs.seeOnTheMap}</div>						
				</div>
			</div>
		`);
	}

	buildMap() {
		this.markers = [];

		this.map = new google.maps.Map(document.querySelector('.map-container'), {
			center: {
				lat: 46.5,
				lng: 1.6
			},
			zoom: 5.5,
			streetViewControl: false,
			mapTypeControl: false,
			fullscreenControl: false,
			gestureHandling: "greedy",
			styles: [
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e9e9e9"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#dadada"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#dadada"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dedede"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#ffffff"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#333333"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f2f2f2"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#fefefe"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				}
			]
		});
	}

	buildMarkers(resellers) {
		const geocoder = new google.maps.Geocoder();
		const leftPanel = this.popup.querySelector(".body .left .results");
		const icon = new google.maps.MarkerImage(
			(mcubeArgs.themeLink + '/svg/marker.svg'),
			new google.maps.Size(30, 30),
			new google.maps.Point(0, 0),
			new google.maps.Point(30, 30),
			new google.maps.Size(30, 30));

		let resellerToUpdate = 0;
		for (let i = 0; i < resellers.length; i++) {
			const reseller = resellers[i];
			const domReseller = document.querySelector(`.reseller[data-id="${reseller.id}"]`);
			this.resellers.push(domReseller);
			if (reseller.lat && reseller.lng) {
				let marker = new google.maps.Marker({
					id: reseller.id,
					position: {
						lat: parseFloat(reseller.lat),
						lng: parseFloat(reseller.lng)
					},
					map: this.map,
					icon: icon
				});
				this.markers[reseller.id] = marker;
				this.clusterer.addMarker(marker);

				let infoWindow = new google.maps.InfoWindow();

				marker.addListener('click', () => {
					if (this.activeInfoWindow) {
						this.activeInfoWindow.close();
					}
					infoWindow.setContent(`
						<div class="map-tooltip-content">
							<div class="name">${reseller.title}</div>
							<div class="address">
								${reseller.address_1} ${reseller.address_2} ${reseller.address_3}<br>
								${reseller.zipcode} ${reseller.city}
							</div>
							<a href="mailto:${reseller.email}" class="email" target="_blank" tabindex="0">${reseller.email}</a>
							<a href="${reseller.website}" class="website" target="_blank" rel="noreferrer noopener nofollow">${reseller.website}</a>
							<div class="choose-reseller text-underline-arrow ${reseller.email ? "has-email" : "d-none"}" data-email="${reseller.email}">${mcubeArgs.chooseThisDealer}</div>	
						</div>
					`);
					infoWindow.open(this.map, marker);
					setTimeout(() => {
						this.buildChooseResellersButton(domReseller, document.querySelector(".map-container .map-tooltip-content .choose-reseller"));
					}, 0);

					leftPanel.scrollTo({top: domReseller.offsetTop - (window.innerWidth < 768 ? 150 : 300)});

					const previous = this.popup.querySelector(".reseller.active");
					if (previous) {
						previous.classList.remove("active");
					}
					domReseller.classList.add("active");
					this.activeInfoWindow = infoWindow;
				});

				domReseller.marker = marker;
				domReseller.resellerData = reseller;

				this.buildChooseResellersButton(domReseller, domReseller.querySelector(".choose-reseller"));
				domReseller.querySelector(".zoom-on-map").addEventListener("click", (e) => {
					this.map.setZoom(15);
					this.map.panTo(marker.position);
					new google.maps.event.trigger(marker, 'click');
					e.target.focus();
				});
			} else {
				resellerToUpdate++;
				setTimeout(() => {
					let addressToSearch = `${reseller.address_1} ${reseller.zipcode} ${reseller.city} ${reseller.country}`;
					addressToSearch = addressToSearch.replaceAll("’", "'");
					addressToSearch = addressToSearch.replaceAll("\x92", "'");
					geocoder.geocode({'address': addressToSearch}, function (results, status) {
						if (status === google.maps.GeocoderStatus.OK) {
							var latitude = results[0].geometry.location.lat();
							var longitude = results[0].geometry.location.lng();
							fetch(`/update-reseller.php?resellerId=${reseller.id}&lat=${latitude}&lng=${longitude}`).then(response => {
							});
							console.log(addressToSearch, latitude, longitude);
						} else {
							console.log(reseller.title, addressToSearch, status);
						}
					});
				}, 1000 * resellerToUpdate);
			}
		}
		console.log("resellers to update", resellerToUpdate);
	}

	buildChooseResellersButton(reseller, button) {
		if (!button) {
			return;
		}
		button.addEventListener("click", () => {
			this.selectedResellerEmail.value = reseller.resellerData.email;
			this.selectedReseller.innerHTML = `
						<div class="map-tooltip-content">
							<div class="name">${reseller.resellerData.title}</div>
							<div class="address">
								${reseller.resellerData.address_1} ${reseller.resellerDataaddress_2} ${reseller.resellerData.address_3}<br>
								${reseller.resellerData.zipcode} ${reseller.resellerData.city}
							</div>
							<a href="mailto:${reseller.resellerData.email}" class="email" target="_blank" tabindex="0">${reseller.resellerData.email}</a>
							<a href="${reseller.resellerData.website}" class="website" target="_blank" rel="noreferrer noopener nofollow">${reseller.resellerData.website}</a>	
						</div>
					`;
			this.popup.classList.remove("active");
			this.openStoreLocatorButtons.forEach(button => {
				button.classList.add("modify");
			});
		});
	}

	buildFilters() {
		this.popup.querySelector("#resellerCat").addEventListener("change", e => {
			this.resellers.forEach(reseller => {
				if (e.target.value === "all" || reseller.resellerData.reseller_category === e.target.value) {
					if (reseller.marker) {
						reseller.marker.setVisible(true);
					}
					reseller.classList.remove("d-none");
				} else {
					if (reseller.marker) {
						reseller.marker.setVisible(false);
					}
					reseller.classList.add("d-none");
				}
			});
			this.clusterer.repaint();
		});

		this.popup.querySelector("#resellerSearch").addEventListener("keyup", e => {
			const val = e.target.value;
			this.resellers.forEach(reseller => {
				if (reseller.dataset.search.toLowerCase().includes(val.toLowerCase())) {
					if (reseller.marker) {
						reseller.marker.setVisible(true);
					}
					reseller.classList.remove("d-none");
				} else {
					if (reseller.marker) {
						reseller.marker.setVisible(false);
					}
					reseller.classList.add("d-none");
				}
			});
			this.clusterer.repaint();
		});
		this.popup.querySelector("#resellerSearch").addEventListener("search", e => {
			const val = e.target.value;
			if (val && val.length > 2) {
				this.resellers.forEach(reseller => {
					if (reseller.dataset.search.toLowerCase().includes(val.toLowerCase())) {
						if (reseller.marker) {
							reseller.marker.setVisible(true);
						}
						reseller.classList.remove("d-none");
					} else {
						if (reseller.marker) {
							reseller.marker.setVisible(false);
						}
						reseller.classList.add("d-none");
					}
				});
			} else {
				this.resellers.forEach(reseller => {
					if (reseller.marker) {
						reseller.marker.setVisible(true);
					}
					reseller.classList.remove("d-none");
				});
			}
			this.clusterer.repaint();
		});

		const defaultBounds = new google.maps.LatLngBounds(
			new google.maps.LatLng(41, -5),
			new google.maps.LatLng(51.589626, 8.835930));

		const autocomplete = new google.maps.places.Autocomplete(this.popup.querySelector("#resellerAddressSearch"), {
			bounds: defaultBounds,
			componentRestrictions: {country: 'fr'},
		});

		autocomplete.addListener("place_changed", () => {
			{
				let place = autocomplete.getPlace();
				if (place.geometry) {
					this.map.panTo(place.geometry.location);
					this.map.setZoom(12);
				}
			}
		});
	}
}
